import PropTypes from 'prop-types'
import { useContext, useEffect } from 'react'

import { LoadBoardContext } from 'legacy/contexts/loadBoard'
import { useLocalStorageState } from 'legacy/utils/hooks/useLocalStorageState'

import { CarrierDocumentsStatus, CarrierStatus } from 'auth/domain/Carrier'

import { useAnalytics } from '../../hooks/useAnalytics'
import { RMISCompleteBanner } from './RMISCompleteBanner'
import { RMISPendingBanner } from './RMISPendingBanner'
import { RMISUnderReviewBanner } from './RMISUnderReviewBanner'

const ONBOARDING_STORAGE_KEY = 'onboardingComplete'

function RMISBanner(props) {
  const { compact } = props
  const [
    {
      carrier: { status, documents_status: documentsStatus },
    },
  ] = useContext(LoadBoardContext)
  const { analytics } = useAnalytics()

  const isCarrierReady = status === CarrierStatus.Ready
  const isCarrierPending = status === CarrierStatus.Pending
  const isDocumentsUnderReview = documentsStatus === CarrierDocumentsStatus.UnderReview

  const [onboardingComplete, setOnboardingComplete] = useLocalStorageState(
    ONBOARDING_STORAGE_KEY,
    false
  )

  const trackPendingView = useEffect(() => {
    if (!onboardingComplete) {
      const status = isCarrierReady ? 'Complete' : 'Pending'
      analytics.track(['RMIS Onboarding Banner', status, 'View'])
    }
  }, [analytics, isCarrierReady, onboardingComplete])

  function handleClick() {
    window.open(process.env.REACT_APP_RMIS_ONBOARDING_URL)
    analytics.track(['RMIS Onboarding Banner', 'Pending', 'Go to RMIS'])
  }

  function handleClose() {
    setOnboardingComplete(true)
    analytics.track(['RMIS Onboarding Banner', 'Completed', 'Dismiss'])
  }

  if (onboardingComplete) return null

  if (isCarrierPending && isDocumentsUnderReview) return <RMISUnderReviewBanner compact={compact} />

  if (isCarrierReady) return <RMISCompleteBanner onClose={handleClose} />

  return <RMISPendingBanner compact={compact} onClick={handleClick} onLoad={trackPendingView} />
}

RMISBanner.propTypes = {
  compact: PropTypes.bool,
}

RMISBanner.defaultProps = {
  compact: false,
}

export { RMISBanner, ONBOARDING_STORAGE_KEY }
